import { getNodeDimensions } from "./layout";
/** A plain copy of a DOM rect, whose fields are prototype getters a spread drops. */ export function toRect({ x, y, width, height }) {
    return {
        x,
        y,
        width,
        height
    };
}
/** Measured size, else the builder's size for the node type. */ export function nodeSize(node) {
    const fallback = getNodeDimensions(node);
    return {
        width: node.measured?.width ?? node.width ?? fallback.width,
        height: node.measured?.height ?? node.height ?? fallback.height
    };
}
export function overlaps(a, b) {
    return a.x < b.x + b.width && b.x < a.x + a.width && a.y < b.y + b.height && b.y < a.y + a.height;
}
export function inflate(rect, by) {
    return {
        x: rect.x - by,
        y: rect.y - by,
        width: rect.width + 2 * by,
        height: rect.height + 2 * by
    };
}
export function contains(outer, inner) {
    return inner.x >= outer.x && inner.y >= outer.y && inner.x + inner.width <= outer.x + outer.width && inner.y + inner.height <= outer.y + outer.height;
}

//# sourceMappingURL=rect.js.map